import { render } from "./productCategoryThird.vue?vue&type=template&id=0ac8f3d4&scoped=true"
import script from "./productCategoryThird.vue?vue&type=script&lang=js"
export * from "./productCategoryThird.vue?vue&type=script&lang=js"

import "./productCategoryThird.vue?vue&type=style&index=0&id=0ac8f3d4&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac8f3d4"]])

export default __exports__